// removed by extract-text-webpack-plugin
module.exports = {"Row":"_2vT3h1fFMKGM-eFYs4NkfW","Success":"_1lMZHUBoSni-xAM5DgBmFL","SuccessIcon":"_15VfI_ctiXWvJka4AK84sG","Failed":"izsMg5ERsvmXC-KjjNWLh","FailedIcon":"_1KhHlY64J3_lwAGPOetCke","Other":"_1CsJ8441LvdnT9dfDE7iDO","OtherIcon":"_1tF9Sr8uXswsuBbp7CAJ_l","Label":"utXAuZjr9tz4oeq-DIo2j"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PayoutsDetailAmounts/styles.module.css
// module id = 562
// module chunks = 0